
var React = require("react");

class Iframe extends React.Component {

    constructor(){
        super();

    }

    componentDidMount(){
    }

    shouldComponentUpdate() {
        return true;
    }

    getIframe(base, id, version) {       
        if(version != -1){
            return {__html: `<iframe src="${base}?assetid=${id}&version=${version}&mode=1"></iframe>`}
        } else {
            return {__html: `<iframe src="${base}?assetid=${id}&mode=1"></iframe>`}
        }
    }

    render() {
        let {
            base,
            id,
            version
        } = this.props;

        return  <div className="contFrame" ref={f => this.iframe = f}>
                    <div style={this.props.style} dangerouslySetInnerHTML={ this.getIframe(base, id, version) }/>
                </div>
    }
};

module.exports = Iframe;
